import {
  REQUEST_SOIL_SSURGO_ZONES,
  RECEIVE_SOIL_SSURGO_ZONES,
  SOIL_SSURGO_ZONES_FAILURE,
  REQUEST_IMPORTED_SHAPEFILE_DATA,
  RECEIVE_IMPORTED_SHAPEFILE_DATA,
  IMPORTED_SHAPEFILE_DATA_FAILURE,
  GET_MOSAIC_LAYERS_FAILURE
} from '../constants/actionTypes';

export function reqSoilSsurgoZones(imageId) {
  return {
    type: REQUEST_SOIL_SSURGO_ZONES,
    imageId,
  };
}

export function receiveSoilSsurgoZones(zones) {
  return {
    type: RECEIVE_SOIL_SSURGO_ZONES,
    zones,
  };
}

export function soilSsurgoZonesFailure() {
  return {
    type: SOIL_SSURGO_ZONES_FAILURE,
  };
}

export function reqImportedShapefileData(fieldId, userId, eventDate, uuid) {
  return {
    type: REQUEST_IMPORTED_SHAPEFILE_DATA,
    fieldId,
    userId,
    eventDate,
    uuid,
  };
}

export function receiveImportedShapefileData(shapefile) {
  return {
    type: RECEIVE_IMPORTED_SHAPEFILE_DATA,
    shapefile,
  };
}

export function importedShapefileDataFailure() {
  return {
    type: IMPORTED_SHAPEFILE_DATA_FAILURE,
  };
}

export function getMosaicLayersFailure() {
  return {
    type: GET_MOSAIC_LAYERS_FAILURE
  }
}